function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".book_svg__cls-1{fill:#19496b}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "book_svg__Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "book_svg__Capa_1",
  "data-name": "Capa 1"
}, React.createElement("path", {
  className: "book_svg__cls-1",
  d: "M116.3 169.09H22.48a6.3 6.3 0 00-1.18-.56C7.61 165.21 0 155.55 0 141.45V27.15C0 11.36 11.28 0 27 0h61.74a21.25 21.25 0 0115.7 6.49c9.1 9.12 18.17 18.27 27.35 27.31a22.35 22.35 0 017 16.8c-.1 29.18 0 58.36 0 87.54 0 18-5.3 25.29-22.21 30.75a1 1 0 00-.28.2zM90.61 13.28c-.87-.09-1.39-.2-1.92-.2-20.8 0-41.6-.06-62.4 0-7.7 0-13.18 5.76-13.19 13.52v115.89a14 14 0 00.51 3.89c1.79 6.06 6.77 9.51 13.81 9.51h82.54c10.77 0 15.77-5 15.78-15.68V89.7c0-13.1-.06-26.19 0-39.29 0-2.7-.82-3.73-3.6-3.59-4 .2-7.92.07-11.88 0-11.69-.06-19.69-8.07-19.71-19.71.05-4.49.06-9.11.06-13.83z"
}), React.createElement("path", {
  className: "book_svg__cls-1",
  d: "M69.39 97.73H34.71a7.6 7.6 0 01-7.87-6.16 7.41 7.41 0 014.36-8.37 10.18 10.18 0 013.8-.71q34.35-.06 68.7 0c4.89 0 8.27 3.1 8.38 7.44s-3.39 7.79-8.37 7.8c-11.42.03-22.87 0-34.32 0zM69.37 131.43H34.69a7.6 7.6 0 01-7.86-6.18 7.41 7.41 0 014.38-8.36 10.24 10.24 0 013.84-.69q34.35-.06 68.7 0c4.88 0 8.27 3.11 8.36 7.46s-3.4 7.77-8.39 7.79c-11.45.01-22.9-.02-34.35-.02zM54.85 64H35.36c-5.26 0-8.81-3.25-8.7-7.81s3.54-7.43 8.71-7.45h38.64c5.13 0 8.52 3.11 8.51 7.61S79.12 64 74 64c-6.37.07-12.76 0-19.15 0z"
})));

var SvgBook = function SvgBook(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 138.82 169.09"
  }, props), _ref, _ref2);
};

export default SvgBook;